$(document).ready(function() {
    var step = 1;
    order = {
        "services": [
            {
                "job_id": "",
                "service_id": '',
                "service_type": '',
                "skip_loc_type": '',
                "job_area": "",
                "skip_req_days": '14',
                "is_permit": 0,
                "service_name": "",
                "job_start_time": '',
                "job_end_time": '',
                "permit_cost": 0,
                "status": 2,
                "is_schedule": 0,
                "service_cost": 0,
                "job_address": "",
                "job_dates": [],
                "supplier": "",
                "supplier_cost": "",
                "skrapRev": "",
                "quantity": 1,
                "haulage": 0,
                "extra_service_id":0,
                "extra_service_price":0,
                "inner_service_id":0
            }
        ],
        "address_data": {
        },
        "comments": "",
        "purchase_order":"",
        "customer_user_id": "",
        "card_id": "",
        "payment_type": 0,
        "acm_id": "",
        "coupon_detail": {
            "is_coupon": 0,
            "service_rate": '',
            "discount": 0,
            "discount_rate": 0,
            "coupon_id": 0
        },
        "jobs": 1,
        "booked_through_domain" : 1
    };
    var step_done = [1];

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('.select-ajax').on('select2:selecting', function (e) {
        $(this).find('option').remove();
    });

    // go to step 2
    $(document).on('click', '#step-1 .step1', function(e){
        var btn = $(this);
        $.fn.addLoading('#step-1 .step1');
        var address = $('.address').val();
        var job_address = $('.address').text();
        var service_id = $('#service_id').val();
        var service_type_text = $('#service_id').find('option:selected').text();
        var route = $(this).data('route');
        var error = false;
        service_type_text = service_type_text.replace('Hire','');
        console.log(job_address);
        if(address == '' || address == null)
        {
            $('.address').closest('.form-group').find('.parsley-required').text('Please select address');
            error = true;
        }

        if(!error)
        {
            $('.address').closest('.form-group').find('.parsley-required').text('');
        }

        if(service_id == '' || service_id == null)
        {
            $('#service_id').closest('.form-group').find('.parsley-required').text('Please select service');
            error = true;
        }

        if(error)
        {
            $.fn.removeLoading('#step-1 .step1');
            return false;
        }

        $('#service_id').closest('.form-group').find('.parsley-required').text('');
        $('.service-type-text').text(service_type_text);

        var post_code = $('input[name="post_code"]').val();
        $.post(route, {'service_id' : service_id, 'post_code' : post_code}, function(data){
            if(data.count <= 0)
            {
                bootbox.alert('There is no services on this postcode');
                $.fn.removeLoading('#step-1 .step1');

                return;
            }

            order.services[0].service_type = service_id;
            order.job_address = job_address;
            order.services[0].job_address = job_address;
            $("info-post-code").html(job_address.post_code);
            $.fn.removeLoading('#step-1 .step1');

            $('.sub-service-container').html(data.html);
            $('#step-1').hide();
            $('#step-2').show();
            parent.location.hash = "step2";

            step +=1;
            $('.step-anchor').find('li').removeClass('active');
            $('.step-anchor').find('#step' + step).addClass('active');
            step_done.push(2);
        }, 'json');
    });


    $(document).on('click', '.read-more-details', function(e){
        e.preventDefault();
        var html = $(this).closest('div').find('.data-read-more').html();
        bootbox.alert(html);
    });

    $(document).on('click', '.single-service', function(e){
        if($(this).hasClass('active-card'))
        {
            $(this).removeClass('active-card');
            $.fn.resetStep2();
        }else{
            $('.active-card').removeClass('active-card');
            $(this).addClass('active-card');
            var price = $(this).data('rate');
            var service_id = $(this).data('id');
            var skrap = $(this).data('skrap');
            var service_name = $(this).find('.service-title').text();
            $('.total-price-nav').html('£'+ price + ' <span class="tab-text">Inc. Vat</span>');
            order.services[0].service_cost = price;
            order.coupon_detail.service_rate = price;
            order.services[0].service_id = service_id;
            order.services[0].service_name = service_name;
            order.booked_through_domain = skrap;
            $.fn.buildInfo();
            $('.step2-form').show();
            $('.datepicker-future').datepicker({
                format: 'yyyy-mm-dd',
                startDate: "today",
                date: new Date(),
            });

            $('html, body').animate({
                scrollTop: ($('.datepicker-future').offset().top - 100)
            }, 100);
        }

        if(order.services[0].service_type == '2')
        {
            $('.skip_loc_type').show();
        }else{
            $('.skip_loc_type').hide();
        }
    });

    $(document).on('click', '.back-to-step1', function(e){
        step = 1;
        $('.step-anchor').find('li').removeClass('active');
        $('.step-anchor').find('#step' + step).addClass('active');
        $('.steps-wizard').hide();
        $('#step-1').show();
        $.fn.resetStep1();
    });

    $.fn.resetStep1 = function()
    {
        $('.select-ajax').find('option').remove();
        order.services[0].service_type = '';
        $.fn.removeLoading('#step-1 .step1');

        $('.address').val('').trigger('change');
        $('#service_id').val('').trigger('change');
        $('input[name="post_code"]').val('');
        $('.sub-service-container').html('');
        $.fn.resetStep2();
    }

    $.fn.resetStep2 = function()
    {
        $('.address').closest('.form-group').find('.parsley-required').text('');
        $('#service_id').closest('.form-group').find('.parsley-required').text('');
        $('.step2-form').hide();
        $('.active-card').removeClass('active-card');
        $('.datepicker-future').val('').trigger('change');
        order.services[0].service_cost = '';
        order.services[0].service_id = '';
        order.services[0].service_name = '';

    }

    $.fn.resetStep3 = function()
    {
        $('.user-login').find('.form-group').each(function(i) {
            $(this).find('.invalid-feedback').hide();
            $(this).find('input').val('');
        });

        $('input[name=mobile_number]').val('');
        $('input[name=otp]').val('');
        $('.otp-user').hide();
        $('.register-user').hide();
        $('.login-user').hide();
        $('.submitOTP').addClass('checkMobile').removeClass('submitOTP');
        $('.submitRegister').addClass('checkMobile').removeClass('submitRegister');
        $('.submitRegister').addClass('checkMobile').removeClass('submitRegister');
        $('.submitlogin').addClass('checkMobile').removeClass('submitRegister');
        $.fn.removeLoading('.go-to-step2');

    }

    $(document).on('change', 'input[name="road"]', function(e){
        var val = $(this).val();
        if(val == 1)
        {
                bootbox.alert('for more information on permits and controlled parking zones please call 0330 133 1561');
                error = true;
                $.fn.removeLoading('.go-to-step3');
                return false;
        }
    });

    $(document).on('click', '.go-to-step2', function(e) {
        e.preventDefault();
        var btn = $(this);
        $.fn.resetStep3();
        $('#step-3').hide();
        $('#step-2').show();
        step =2;
        $('.step-anchor').find('li').removeClass('active');
        $('.step-anchor').find('#step' + step).addClass('active');
        step_done.push(step);
    });

    // go to step 3
    $(document).on('click', '.go-to-step3', function(e){
        e.preventDefault();
        var btn = $(this);
        $.fn.addLoading('.go-to-step3');

        var date = $('.datepicker-future').val();
        var skip_loc_type = $('input[name=road]:checked').val();
        var comments = $('textarea[name=comments]').val();

        var error = false;
        if(skip_loc_type == 1)
        {
            bootbox.alert('for more information on permits and controlled parking zones please call 0330 133 1561');
            error = true;
            $.fn.removeLoading('.go-to-step3');
            return false;
        }

        if($("input[name=time_option]:checked").length == 0)
        {
            bootbox.alert('please choose time slot');
            error = true;
            $.fn.removeLoading('.go-to-step3');
            return false;
        }

        if($('.active-card').length == 0)
        {
            bootbox.alert('please choose service');
            error = true;
        }

        if(date == '' || date == null)
        {
            $.fn.removeLoading('.go-to-step3');
            error = true;
            return false;
        }

        if(error)
        {
            $.fn.removeLoading('.go-to-step3');
            return false;
        }

        var time = $("input[name=time_option]:checked").val();
        var end = '';
        if(time == '8')
        {
            time = '08:00:00';
            end = '12:00:00';

        }else{
            time = '12:00:00';
            end = '17:00:00';
        }

        if(skip_loc_type == '')
        {
            skip_loc_type = 0;
        }

        var full_date = date + ' ' + time;
        var full_end_date = date + ' ' + end;
        var unixTimestamp = moment(full_date, "YYYY-MM-DD hh:mm:ss").unix();
        var unixTimestampEnd = moment(full_end_date, "YYYY-MM-DD hh:mm:ss").unix();
        unixTimestamp = unixTimestamp * 1000;
        unixTimestampEnd = unixTimestampEnd * 1000;
        order.services[0].job_start_time = unixTimestamp;
        order.services[0].job_end_time = unixTimestampEnd;
        order.services[0].job_dates = [unixTimestamp];
        order.services[0].skip_loc_type = skip_loc_type;
        order.comments = comments;

        var useCredit = $('input[name=useCredit]').val();

        if(useCredit == '1')
        {
            order.payment_type = 2;
        }else{
            $('.payment_type-container').hide();
            $('#paymentTypeCard').attr('checked', 'checked');
            $('#paymentTypeCredit').removeAttr('checked');
            $('.cards-main-container').show();
        }

        $('#step-2').hide();
        $('#step-3').show();
        $.fn.removeLoading('.go-to-step3');
        step +=1;
        $('.step-anchor').find('li').removeClass('active');
        $('.step-anchor').find('#step' + step).addClass('active');
        step_done.push(3);
    });


    // step 3
    var create_account = false;
    $(document).on('click', '.checkMobile', function(e){
        $button = $(this);
        var userId = $('input[name=user_id]').val();
        if(userId != '')
        {
            order.customer_user_id = user_id;

            $('#step-3').hide();
            $('#step-4').show();
            $.fn.removeLoading('.submitlogin');
            $.fn.buildInfo();
            step +=1;
            $('.step-anchor').find('li').removeClass('active');
            $('.step-anchor').find('#step' + step).addClass('active');
            step_done.push(4);
            return true;
        }

        $.fn.addLoading('.checkMobile');
        $input = $('input[name=mobile_number]');
        var value = $input.val();
        if (value == '' || value.length < 10 || value.length > 10) {
            $input.closest('.form-group').find('.invalid-feedback').show();
            $input.closest('.form-group').find('.invalid-feedback').find('strong').text('The mobile must be 10 number.');
            $.fn.removeLoading('.checkMobile');
            return false;
        }
        $input.closest('.form-group').find('.invalid-feedback').find('strong').text('');
        if (!create_account) {
            $.post('/web/account/check', {'type': 'mobile', 'value': value}, function (result) {
                $.fn.removeLoading('.checkMobile');
                if(result.code == 3) {
                    bootbox.alert(result.message);
                    return false;
                }else if (result.code == 0) {
                    //$input.attr('readonly', 'readonly');
                    //$('.register-user').fadeIn();
                    //$('.checkMobile').addClass('submitRegister').removeClass('checkMobile');
                    $('.otp-user').fadeIn();
                    $('.checkMobile').addClass('submitOTP').removeClass('checkMobile');
                    create_account = true;
                    return false;
                } else {
                    user_id = result.account.user_id;
                    $('input[name=user_id]').val(user_id);
                    $('.login-user').fadeIn();
                    $('.checkMobile').addClass('submitlogin').removeClass('checkMobile');
                    order.customer_user_id = user_id;
                }
            }, 'json');
        } else {
            var first_name = $('input[name=first_name]');
            var last_name = $('input[name=last_name]');
            var email = $('input[name=email]');
            var agent_id = $('select[name=agent_id]').val();
            first_name.next().text('');
            last_name.next().text('');
            email.next().text('');

            var hasError = false;

            if (first_name.val() == '') {
                first_name.next().text('This field is required');
                hasError = true;
            }

            if (last_name.val() == '') {
                last_name.next().text('This field is required');
                hasError = true;
            } else {
                last_name.next().text('');
            }
            if (email.val() == '') {
                email.next().text('This field is required');
                hasError = true;
            } else if (!validateEmail(email.val())) {
                email.next().text('Invalid email');
                hasError = true;
            } else {
                // check if this email registred on the system
                $.post('/accounts/search', {'type': 'email', 'value': email.val()}, function (data) {
                    $.fn.removeLoading('.checkMobile');
                    if (data.status == 0) {
                        $.post('/accounts/create', {
                            'first_name': first_name.val(),
                            'last_name': last_name.val(), 'email': email.val(),
                            'mobile': value,
                            'agent_id': agent_id
                        }, function (result) {
                            if (result.code == 1) {
                                user_id = result.result.user_id;
                                order.customer_user_id = user_id;
                                $('input[name=customer_user_id]').val(result.result.user_id);
                                console.log('11');
                                $.fn.getCustomerCard($button, user_id);
                            }
                        }, 'json');

                    } else {
                        email.next().text('This email registred before with name ' + data.data.first_name + ' ' + data.data.last_name + ' ' + data.data.mobile_number);
                        $.fn.removeLoading('.checkMobile');
                        return false;
                        hasError = true;
                    }
                }, 'json');
            }
        }
    });

    $(document).on('keyup', 'input[name=mobile_number]', function(e){
        e.preventDefault();
        $input = $(this);
        $input.inputFilter(function(value) {
            return /^\d*$/.test(value);    // Allow digits only, using a RegExp
        });

        var value = $input.val();
        if (value.length > 10) {
            $input.closest('.form-group').find('.invalid-feedback').show();
            $input.closest('.form-group').find('.invalid-feedback').find('strong').text('The mobile must be 10 number.');
            return false;
        }
        $input.closest('.form-group').find('.invalid-feedback').find('strong').text('');
        $('.register-user').hide();
        $('.otp-user').hide();
        $('.login-user').hide();
        $('.submitOTP').addClass('checkMobile').removeClass('submitOTP');
        $('.submitOTP').addClass('checkMobile').removeClass('submitOTP');
        $('.submitRegister').addClass('checkMobile').removeClass('submitRegister');
        $('.submitRegister').addClass('checkMobile').removeClass('submitRegister');
        $('.submitlogin').addClass('checkMobile').removeClass('submitRegister');
        create_account = false;
        $('input[name=user_id]').val('');
    });


    $(document).on('keyup', 'input[name=mobile_number]', function(e){
        e.preventDefault();
        $input = $(this);
        var value = $input.val();

        if(value < 10 || value > 10)
        {
            $('.login-user').fadeOut();
            $('.submitlogin').addClass('checkMobile').removeClass('submitlogin');
            $('.submitRegister').addClass('checkMobile').removeClass('submitRegister');
            $('.submitOTP').addClass('checkMobile').removeClass('submitOTP');
            $('.submitRegister').addClass('checkMobile').removeClass('submitRegister');
            $('.submitlogin').addClass('checkMobile').removeClass('submitRegister');
            $input.next().text('The mobile must be 10 number.');
            return false;
        }

    });

    $(document).on('click', '.submitlogin', function(e){
        $.fn.addLoading('.submitlogin');
        var mobile = $('input[name=mobile_number]').val();
        var password = $('input[name=password]').val();
        mobile = '+44' + mobile;
        $.post('/web/login', {'username' : mobile, 'password' : password, 'booked' : true}, function(data){

            if(typeof data.useCredit !== 'undefined')
            {
                if(data.useCredit == false)
                {
                    $('.payment_type-container').hide();
                    $('#paymentTypeCard').attr('checked', 'checked');
                    $('#paymentTypeCredit').removeAttr('checked');
                    $('.cards-main-container').show();
                }else{
                    order.payment_type = 2;
                }
            }

            order.customer_user_id = data.user.user_id;
            $('input[name=mobile_number]').closest('.form-group').find('.invalid-feedback').find('strong').text('');
            $('input[name=password]').closest('.form-group').find('.invalid-feedback').find('strong').text('');
            $('#step-3').hide();
            $('#step-4').show();
            $.fn.removeLoading('.submitlogin');
            $.fn.buildInfo();
            step +=1;
            $('.step-anchor').find('li').removeClass('active');
            $('.step-anchor').find('#step' + step).addClass('active');
            step_done.push(4);
        },'json').fail(function (data) {
            $('#loader').addClass('fadeOut');
            $('.invalid-feedback').show();
            $.each(data.responseJSON.errors, function (i, v) {
                console.log(i);
                $('.' + i).closest('.form-group').find('.invalid-feedback').find('strong').text(v);
                $('.' + i).focus();
                $('#loader').addClass('fadeOut');
                $.fn.removeLoading('.submitlogin');
            });
        });
    });

    $(document).on('click', '.submitOTP', function(e){
        $button = $(this);
        var userId = $('input[name=user_id]').val();

        $.fn.addLoading('.submitOTP');
        $input = $('input[name=mobile_number]');
        var value = $input.val();
        if (value == '' || value.length < 10 || value.length > 10) {
            $input.closest('.form-group').find('.invalid-feedback').show();
            $input.closest('.form-group').find('.invalid-feedback').find('strong').text('The mobile must be 10 number.');
            $.fn.removeLoading('.submitOTP');
            return false;
        }
        $input.closest('.form-group').find('.invalid-feedback').find('strong').text('');
        var otp = $('input[name=otp]').val();
        $.post('/web/account/checkOTP', {'mobile_number' : value, 'otp' : otp}, function(data) {
            $.fn.removeLoading('.submitOTP');
            if(data.code == '0')
            {
                $('.otp-user').fadeOut();
                $('.register-user').fadeIn();
                $('.submitOTP').addClass('submitRegister').removeClass('submitOTP');
            }else{
                $('.invalid-feedback').show();
                $.fn.removeLoading('.submitOTP');
                $('input[name=otp]').closest('.form-group').find('.invalid-feedback').find('strong').text('Invalid OTP');
                $('input[name=otp]').focus();
            }
        }, 'json').fail(function (data) {
            $('#loader').addClass('fadeOut');
            $('.invalid-feedback').show();
            $.each(data.responseJSON.errors, function (i, v) {
                $('.' + i).closest('.form-group').find('.invalid-feedback').find('strong').text(v);
                $('.' + i).focus();
                $('#loader').addClass('fadeOut');
                $.fn.removeLoading('.submitOTP');
            });
        });
    });
    $(document).on('click', '.submitRegister', function(e){
        $.fn.addLoading('.submitRegister');
        $('.invalid-feedback').each(function(i, v){
            $(this).find('strong').text('');
        });
        $('.invalid-feedback').hide();
        var form  = $(this).closest('form');
        var data = form.serializeArray();
        $.post('/web/account/register', data, function(data){
            $.fn.removeLoading('.submitRegister');
            if(data.code == 0) {
                $('input[name=user_id]').val(data.result.user_id);
                order.customer_user_id = data.result.user_id;
                $('#step-3').hide();
                $('#step-4').show();
                step += 1;
                $('.step-anchor').find('li').removeClass('active');
                $('.step-anchor').find('#step' + step).addClass('active');
                $.fn.buildInfo();

            }
        }, 'json').fail(function (data) {
            $('#loader').addClass('fadeOut');
            $('.invalid-feedback').show();
            $.each(data.responseJSON.errors, function (i, v) {
                console.log(i);
                $('.' + i).closest('.form-group').find('.invalid-feedback').find('strong').text(v);
                $('.' + i).focus();
                $('#loader').addClass('fadeOut');
                $.fn.removeLoading('.submitRegister');
            });
        });
    });

    $.fn.buildInfo = function(){
        var date = moment.unix(order.services[0].job_dates / 1000).format('MMMM Do YYYY, h:mm:ss a');
        $('.info-post-code').text(order.address_data.postcode);
        $('.info-service-name').text(order.services[0].service_name);
        $('.info-service-name').text(order.services[0].service_name);
        $('.info-delivery-date').text(date);
        $('.info-address').text(order.job_address);
        $('.info-price').html('£' + order.services[0].service_cost + ' <small>(Inc. VAT)</small>');
        $('.info-price').text('£' + order.services[0].service_cost + ' (Inc. VAT)');
    }

    $('.create-card-booking').closest('form').submit(function(e) {
        e.preventDefault();
        var cardType = $.payment.cardType($('.cc-number').val());
        $('.cc-number').toggleInputError(!$.payment.validateCardNumber($('.cc-number').val()));
        $('.cc-exp').toggleInputError(!$.payment.validateCardExpiry($('.cc-exp').payment('cardExpiryVal')));
        $('.cc-cvc').toggleInputError(!$.payment.validateCardCVC($('.cc-cvc').val(), cardType));
        $('.cc-brand').text(cardType);
        $('.validation').removeClass('text-danger text-success');
        $('.validation').addClass($('.has-error').length ? 'text-danger' : 'text-success');
    });

    $(document).on('click', 'input[name=payment_type]', function(e){
        var value = $('input[name="payment_type"]:checked').val();

        if(value == '0')
        {
            $('.cards-main-container').fadeIn();
        }else{
            $('.cards-main-container').fadeOut();
        }

        order.payment_type = value;
    });

    $(document).on('click', '.create-card-booking', function(e){
        $.fn.addLoading('.create-card-booking');
        var user_id = order.customer_user_id;
        if(user_id == '')
        {
            user_id = $('input[name=user_id]').val();
        }
        var number = $(this).closest('form').find('.cc-number').val();
        var exp = $(this).closest('form').find('.cc-exp').val();
        var cvc = $(this).closest('form').find('.cc-cvc').val();
        $(this).attr('disabled', 'disabled');
        $(this).addClass('disabled');

        if(globals.secure_asset == 'https://lordsbm.skrap.app/') {

            order.payment_type = 2;
            order.card_id = false;
        }

        //for lordsm
        if(order.payment_type == '2')
        {
            order.card_id = false;
            $.post('/web/order', order, function(data){
                $.fn.removeLoading('.create-card-booking');
                console.log(data);
                $('.card-payment').hide();
                $('.info-order-id').text(globals.job_prefix + data.result.jobs[0].job_id);
                $('.order-success').show();
                bootbox.confirm({
                    title: "Booking accepted",
                    message: "Thanks so much for your order. Please note that subject to availability your delivery date and AM and PM requests are not guaranteed until your order is confirmed. " +
                        "Thanks for your patience.",
                    buttons: {
                        confirm: {
                            label: '<i class="fa fa-check"></i> Confirm'
                        }
                    },
                    callback: function (result) {
                    }
                });

                //Start TradeDoubler Conversion Tag Insert on confirmation Page
                    tdconv('init', '2290630', {'element': 'iframe' });
                    tdconv('track', 'sale', {'transactionId':data.result.jobs[0].job_id, 'ordervalue':order.services[0].service_cost, 'voucher':'VoucherCode', 'currency':'GBP', 'event':'412266'});

            }, 'json');

            return 1;
        }


        $.post('/web/account/create-card', {'user_id': user_id, 'card_number' : number, 'exp' : exp, 'cvc' : cvc}, function(data){

            if(data.code == 0)
            {
                var source = data.result.id;
                order.card_id = source;

                $.post('/web/order', order, function(data){
                    $.fn.removeLoading('.create-card-booking');
                    console.log(data);
                    if(data.code == 0)
                    {
                        //Start TradeDoubler Conversion Tag Insert on confirmation Page
                        tdconv('init', '2290630', {'element': 'iframe' });
                        tdconv('track', 'sale', {'transactionId':data.result.jobs[0].job_id, 'ordervalue':order.services[0].service_cost, 'voucher':'VoucherCode', 'currency':'GBP', 'event':'412266'});

                        $('.card-payment').hide();
                        $('.info-order-id').text(globals.job_prefix + data.result.jobs[0].job_sequence);
                        $('.order-success').show();
                        bootbox.dialog({
                            title: "Booking accepted",
                            message: "Thanks so much for your order. Please note that subject to availability your delivery date and AM and PM requests are not guaranteed until your order is confirmed. " +
                                "Thanks for your patience.",
                            buttons: {
                                confirm: {
                                    label: '<i class="fa fa-check"></i> Confirm'
                                }
                            },
                            callback: function (result) {
                            }
                        });
                    }else{
                        if(typeof data.description !== 'undefined')
                        {
                            bootbox.alert(data.description);
                        }else{
                            bootbox.alert('Unexpected error');
                        }

                    }

                }, 'json');
            }else{
                if(typeof data.description !== 'undefined')
                {
                    bootbox.alert(data.description);
                }else{
                    bootbox.alert('Something went wrong, Please contact 036565489645');
                }

                $.fn.removeLoading('.create-card-booking');
            }
        }, 'json').fail(function(response){
            var data = response.responseJSON;
            $.fn.removeLoading('.create-card-booking');
            if(data.hasOwnProperty('errors'))
            {
                $('.invalid-feedback').show();
                console.log(data);
                $.each(data.errors, function(i, value) {
                    $('.invalid-' + i).find('strong').html(value);
                });
            }
        }, 'json');

    });

    $(document).on('keyup', 'textarea[name="comments"]', function(e){
        e.preventDefault();
        var comment = $(this).val();
        $('.comments-job').html(comment);
    });

    $(document).on('click', '.btn-skrap, .get-quote', function(){
        $('html, body').animate({
            scrollTop: ($('#content').offset().top)
        }, 100);
    });

    $('#bologna-list a').on('click', function (e) {
        e.preventDefault()
        $(this).tab('show')
    });

    $(document).on('click', '.editDetailsBtn', function(e){
        e.preventDefault();
        $('#MyDetailsInfo').hide();
        $('#MyDetailsEdit').show();

    });

    $(document).on('click', '#wizard .nav-item', function(e) {
        e.preventDefault();
        var number = $(this).index() + 1;
        console.log(step_done);
        if(step_done.includes(number))
        {
            step = number;
            $('.steps-wizard').hide();
            $('#step-' + step).show();
            $('.step-anchor').find('li').removeClass('active');
            $('.step-anchor').find('#step' + step).addClass('active');
        }
    });

    $(document).on('click', '.go-to-step', function(e){
        var step = $(this).data('step');
    });

    $(document).on('change', '.datepicker-future', function(e){
        var date = $(this).val();
        var url = $(this).data('url');
        $('.timeslot-container').html('');

        $.post(url, {'date' : date}, function(data){
            if(data.result.time_slots.length == 0)
            {
                $('.timeslot-container').append('No time slot available');
            }else{
                var ii = 1;
                $.each(data.result.time_slots, function(i, v){

                    var type = 8;
                    if(v.time_slot == '12:00 PM - 05:00 PM')
                    {
                        type = 12;
                    }

                    var html = '<label class="btn btn-sm btn-primary ' + (ii == 1 ? 'active' : '')+ '">\n' +
                        '                            <input type="radio" name="time_option" value="'+ type + '"\n' +
                        '                                   id="time_option'+ i +'" \n' +
                        '                                   autocomplete="off" '+ (type == 8 ? 'checked' : '') +'> ' + v.time_slot + '\n' +
                        '</label>';
                    $('.timeslot-container').append(html);
                    $('.btn-group-toggle').button('toggle')

                    ii++;
                });
            }


        }, 'json');
    });

    $.fn.addLoading = function(selector)
    {
        var element = $(selector);
        element.addClass('disabled');
        element.append('<i class="btn-loading fa fa-refresh fa-spin"></i>');
        element.attr('disabled', 'disabled');

        return true;
    }

    $.fn.removeLoading = function(selector)
    {
        var element = $(selector);
        element.removeClass('disabled');
        element.find('.btn-loading').remove();
        element.removeAttr('disabled');

        return true;
    }

    $(document).on('click', '.openDetails', function(e){
        var job_id = $(this).data('id');
        var url = $(this).data('url');
        $.post(url, {'job_id' : job_id}, function(data){
            $('.details-job').html(data.html);
        }, 'json');
    });

    function locationHashChanged() {
        console.log(location);
        if (location.hash === '') {
            step = 1;
            $('.step-anchor').find('li').removeClass('active');
            $('.step-anchor').find('#step' + step).addClass('active');
            $('.steps-wizard').hide();
            $('#step-1').show();
            $.fn.resetStep1();
        }
    }

    window.onhashchange = locationHashChanged;

});

(function($) {
    $.fn.inputFilter = function(inputFilter) {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    };
}(jQuery));


require('jquery.payment')

$.fn.paymentInit = function() {
    $('[data-numeric]').payment('restrictNumeric');
    $('.cc-number').payment('formatCardNumber');
    $('.cc-exp').payment('formatCardExpiry');
    $('.cc-cvc').payment('formatCardCVC');
    $.fn.toggleInputError = function(erred) {
        this.parent('.form-group').toggleClass('has-error', erred);
        return this;
    };
}

$.fn.paymentInit();



// WEBPACK FOOTER //
// ./resources/js/app/wizards/index.js